import { ChartConfig } from '../features/scm/material-management/v1/components/sv-charts-settings/sv-charts-settings.types';

export class UserSettingsCls {
  data!: string;
  key!: string;
}

export type UserSettings = {
  data: string;
  key: string;
};

export type NewUserSetting = UserSettings;

export type DummyCommitHeader = {
  createdBy?: string;
  dateCreated?: string;
  dateModified?: string;
  enumSimulationSet?: number;
  forPrecalculate?: boolean;
  id?: string;
  modifiedBy?: string;
  name: string;
  partNumber: string;
  vendorCode?: string;
};

export type LoadState = {
  isCommentLoaded?: boolean | null;
  isCommitsLoaded?: boolean | null;
  isForecastLoaded?: boolean | null;
  isInfoLoaded?: boolean | null;
  isNotesLoaded?: boolean | null;
};

export type WaterfallDto = {
  ColumnPeriods?: number;
  date?: string;
  partNoVendors?: PnVendorCode[];
  RowPeriods?: number;
};

export type PnVendorCode = {
  partNumber?: string;
  plant?: string;
  vendorCode?: string;
};

export type BasicParameters = {
  $avlLoaded?: boolean;
  $loaded?: boolean;
  currentPartNumber?: number;
  days?: number;
  fontSize?: number;
  mmViewID?: string;
  partNumber?: string;
  plant?: string;
  records?: number;
  variant?: string;
  vendorCode?: string;
  weeks?: number;
  widgetId?: string;
};

export class DateRangeParameters {
  dateFrom?: Date | string;
  dateTo?: Date | string;
}

export type SvUrlWithParams = {
  params: {};
  url: string;
};

export type StaticValue = {
  [key: string]: unknown;
};

export type ChartSetting = {
  data: unknown;
  dateKey: string;
  downloadedData: unknown;
  name: string;
  order: number;
  qlikAppId: string;
  series: ChartSeries[];
  showDateAsWeeks: boolean;
  tableName: string;
  type: string;
  xAxisLabel: string;
  yAxisLabel: string;
};

type ChartSeries = {
  name: string;
  nameKey: string;
  valueKey: string;
};

export type PNVendor = {
  partNumber: string;
  vendorCode: string;
};

export type ExcelDownloadInstructions = {
  fontSize?: number;
  forecastDate?: string[];
  materialManagementViewID?: string;
  partNoVendors?: PartNoVendorUrl[];
  plant?: string | unknown;
  records?: number;
  timeZone?: string;
  userId?: string;
  variant?: string;
};

export type PartNoVendorUrl = {
  url: string;
};

export type PrecalculationResponse = {
  success?: {
    url?: string;
  };
};

export type TemplatePayload = {
  data?: ChartConfig | string;
  id?: string;
  isActive?: boolean;
  isDefault?: boolean;
  key?: string;
  name?: string;
  plant?: string;
  type?: string;
};

export enum EnumSvSidebarSection {
  None = -1,
  Notes = 0,
  Comments = 1,
  PNInfo = 2,
  PredefinedComments = 3,
}

export class CommitVisualization {
  columnSort!: Array<{ direction: string; field: string }> | null;
  pageSettings!: { pageIndex: number; pageSize: number };
}

export enum EnumCommitFieldStructure {
  CommitTable = 0,
  CommitForm = 1,
  BulkEditForm = 2,
  SplitForm = 3,
  HistoryTable = 4,
  DocumentTable = 5,
  DocumentCreateForm = 6,
  DocumentEditForm = 7,
  ChartSettingsTable = 8,
  ChartSettingsCreateForm = 9,
  ChartSettingsEditForm = 10,
  CommitHistoryTable = 11,
  TemplateFilterTable = 12,
  TemplateFilterCreateForm = 13,
  TemplateFilterEditForm = 14,
}

export class FieldVisibilitySetting {
  field!: string;
  visible = false;
  index?: number;
  headerText?: string;
  isRequired?: boolean;
  type?: number | string;
}
